module.exports = __webpack_public_path__ + "static/media/work-laptop.913ec81a.png";